// @flow

import React from 'react';
import styled from 'styled-components';

import { useImages } from 'hooks';
import { absolute, flex, Color, maxWidthContainer, Width } from 'styles';
import { ImageLoader } from 'components/Gui';
import type { AllImages } from 'hooks/use-images';

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  height: 320px;
  padding: 4px 0;
  box-sizing: border-box;
  background: ${Color.MARKETS_RED};
  ${flex()};
  flex-direction: column;
`;

const Image = styled.div`
  ${absolute('4px', 0, '4px', 0)};
  z-index: 1;
`;

const Content = styled.div`
  ${maxWidthContainer(1080)};
  position: relative;
  z-index: 1;

  h1 {
    font-size: 3.2rem;
    color: ${Color.MARKETS_RED};
    margin-bottom: 0;

    @media (min-width: ${Width.BREAK_MD}px) {
      font-size: 5rem;
    }
  }

  h2 {
    display: inline-block;
    padding: 8px 8px 8px 8px;
    font-weight: 400;
    background: rgba(359, 86, 92, 0.8);
    color: white;
    font-size: 2rem;

    @media (min-width: ${Width.BREAK_MD}px) {
      font-size: 2.4rem;
      padding: 8px 200px 8px 8px;
    }
  }
`;

type Props = {
  image: {
    name: string,
    alt: string,
  },
  title: string,
  blurb: string,
  images: AllImages,
};

const MarketsHero = ({ image: { name, alt }, title, blurb, images, ...rest }: Props) => {
  const heroImage = useImages(images)(name);
  return (
    <Wrapper {...rest}>
      <Image>
        <ImageLoader image={heroImage} alt={alt} fitContainer />
      </Image>
      <Content>
        <h1>{title}</h1>
        <h2>{blurb}</h2>
      </Content>
    </Wrapper>
  );
};

export default MarketsHero;
